import React from "react";
import "./ConfirmModal.scss";

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmMent?: string;
  cancelMent?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  confirmMent = '',
  cancelMent = '',
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="confirm-overlay">
      <div className="confirm-modal-wrap">
        <h2>{title}</h2>
        <p dangerouslySetInnerHTML={{ __html: message || "" }}></p>
        <div className="confirm-button-wrap">
          <button onClick={onCancel} className="cancel">
            {cancelMent || '아니요'}
          </button>
          <button onClick={onConfirm} className="confirm">
            {confirmMent || '네! 알겠습니다.'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
